import { Controller } from "@hotwired/stimulus"

export default class DisableClick extends Controller {
  static values = {
    timeout: { type: Number, default: 20000 }
  }

  connect() {
    this.enabled = true
  }

  disable(event) {
    if (!this.enabled) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }

    this.enabled = false

    this.element.classList.add("disabled")
    this.element.style.pointerEvents = "none"

    setTimeout(() => {
      this.enable()
    }, this.timeoutValue)
  }

  enable() {
    this.enabled = true
    this.element.classList.remove("disabled")
    this.element.style.pointerEvents = ""
  }
}
